import { WpPayment } from './wp-payment.model';

export class WpVendor {
    constructor(
        public id?: number,
        public vendorName?: string,
        public vendorContactPersonName?: string,
        public addrLine1?: string,
        public addrLine2?: string,
        public addrCity?: string,
        public addrStateCd?: string,
        public addrZip5?: string,
        public vendorPhoneNumber?: string,
        public isVendorValid?: string,
        public wpPayment?:WpPayment,

    ) {
    }
}








// WEBPACK FOOTER //
// ./src/app/shared/model/wp-vendor.model.ts